import classNames from 'classnames'
import { MarkIconType, MarkType } from 'feature/YandexMap/types'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { useEffect } from 'react'
import { useActions } from 'store/hooks'

import style from './ConfirmAddressBlock.module.scss'
import styleInformation from 'widget/InformationBlock/InformationBlock.module.scss'

type ConfirmAddressBlockProps = {
  address: string | undefined
  geoLat: string | null | undefined
  geoLon: string | null | undefined
}

export function ConfirmAddressBlock({
  address,
  geoLat,
  geoLon,
}: ConfirmAddressBlockProps) {
  const { setStaticMarkCoords, setStaticMarkIcon, setCenter } = useActions()

  useEffect(() => {
    if (!geoLat || !geoLon) return

    setStaticMarkCoords([Number(geoLat), Number(geoLon)])
    setStaticMarkIcon(MarkIconType.building)
    setCenter([Number(geoLat), Number(geoLon)])
  }, [geoLat, geoLon])

  return (
    // TODO: карта не отображается если ее передавать в <InformationBlock/>
    <div className={styleInformation.informationBlock}>
      <div className={styleInformation.title}>
        <span className='h4'>Адрес объекта</span>
      </div>

      <div className={style.informationBlockContent}>
        <span className={classNames('default-text', style.addressText)}>
          {address}
        </span>
        <YandexMap
          className={style.map}
          isMapClickable={false}
          hideControls={true}
          marks={[MarkType.staticMark]}
          controls={null}
        />
      </div>
    </div>
  )
}
